import { TDevSandboxMode } from './types';

export interface IEntityFeatures {
  showFramework: boolean;
  /** When true, only show JS and TS framework options (hide React, Vue, etc.) */
  jsOnlyFramework: boolean;
  showCssMode: boolean;
  showRunTests: boolean;
  showPackages: boolean;
}

export const ENTITY_FEATURES: Record<string, IEntityFeatures> = {
  demo: { showFramework: true, jsOnlyFramework: false, showCssMode: true, showRunTests: false, showPackages: true },
  project: { showFramework: true, jsOnlyFramework: false, showCssMode: true, showRunTests: false, showPackages: true },
  challenge: { showFramework: true, jsOnlyFramework: false, showCssMode: true, showRunTests: false, showPackages: true },
  practice: { showFramework: true, jsOnlyFramework: true, showCssMode: false, showRunTests: true, showPackages: false },
  prototype: { showFramework: true, jsOnlyFramework: false, showCssMode: true, showRunTests: false, showPackages: true },
  codeframe: { showFramework: true, jsOnlyFramework: false, showCssMode: true, showRunTests: false, showPackages: true },
};

export const getEntityFeatures = (mode?: TDevSandboxMode): IEntityFeatures => {
  if (mode === 'script-practice') {
    return ENTITY_FEATURES.practice;
  }
  return ENTITY_FEATURES.demo;
};
